import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";

// components
import MainHeader from "../../components/Header/MainHeader";
import SelectOption from "../../components/Select/SelectOption";

// methods
import useResponse from "../../hooks/useResponse";
import ServicesAPI from "../../services/services";
import { addEmploymentDetails } from "../../redux/slices/registerSlice";
import { useNavigate } from "react-router-dom";
import { googleEvent_LOJ058 } from "../../lib/google-analytics";
import { googleEvent_LOJ056 } from "../../lib/google-analytics-loan-journey-events";

export default function EmployementDetails() {
  const [loading, setLoading] = useState(false);

  const { employmentDetails } = useSelector((state) => state.register);
  const { repeatCustomer } = useSelector((state) => state.user);

  console.log("repeatCustomer------------", repeatCustomer);

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { incompleteDetailsUpdate } = new ServicesAPI();
  const { handleStep } = useResponse();

  const data = [
    { label: "Salaried", value: "Salaried" },
    { label: "Self Employed", value: "Self Employee" },
  ];

  const handleIncompleteDetailsUpdateAPI = async (data) => {
    setLoading(true);

    const res = await incompleteDetailsUpdate(data, repeatCustomer);

    if (res && res.statusCode === 200) {
      dispatch(addEmploymentDetails(data));

      if (repeatCustomer) {
        navigate("/confirm-details");
      } else {
        handleStep();
      }
    }

    setLoading(false);
  };

  useEffect(() => {
    googleEvent_LOJ056();
  }, []);

  return (
    <>
      <div className="wrapper">
        <MainHeader
          title="Professional Details"
          showProgress={true}
          percent={30.76}
          backPageName={repeatCustomer ? "/confirm-details" : ""}
        />

        <div className="mb-3">
          <p className="label">Employment Details</p>
        </div>

        {data.map((item, index) => (
          <div
            key={index}
            onClick={async () => {
              handleIncompleteDetailsUpdateAPI({
                key: "employeeType",
                value: item.value,
              });

              // Events
              googleEvent_LOJ058(item, item);
            }}
          >
            <SelectOption name={item.label} checked={employmentDetails} />
          </div>
        ))}
      </div>

    </>
  );
}
